import { Factory } from 'rosie';

Factory.define('RoutableCounts')
  .attr('MESSAGING', 0)
  .attr('NON_INTERACTIVE', 0)
  .attr('TASK', 0)
  .attr('VOICE', 0);
